import React, { Component } from 'react';
import logo from './logo.png';
import github from './github.svg';
import './App.css';
import QProgress from 'qier-progress';

class App extends Component {
  constructor(props) {
    super(props)
    this.colorful = true

    this.qprogressColorful = null
    this.qprogress = null
  }

  componentDidMount() {
    this.qprogressColorful = new QProgress({
      colorful: true,
    })
    this.qprogress = new QProgress({
      colorful: false
    })
  }

  componentWillUnmount() {
    this.qprogressColorful = null
    this.qprogress = null
  }

  start = () => {
    this.colorful ? this.qprogressColorful.start() : this.qprogress.start()
  }

  set = () => {
    this.colorful ? this.qprogressColorful.set(0.1) : this.qprogress.set(0.1)
  }

  inc = () => {
    this.colorful ? this.qprogressColorful.inc(0.1) : this.qprogress.inc(0.1)
  }

  finish = () => {
    this.colorful ? this.qprogressColorful.finish() : this.qprogress.finish()
  }

  switchToColor = () => {
    if (this.colorful) {
      this.qprogressColorful.finish()
      this.qprogress.start()
    } else {
      this.qprogress.finish()
      this.qprogressColorful.start()
    }
    
    this.colorful = !this.colorful
  }

  render() {
    return (
      <div className="App">
        <div className="header">

        </div>
        <div className="logo">
          <img src={logo} alt="logo" onClick={this.switchToColor}/>
          <p className="tips">Click me switch to colorful mode</p>
        </div>
        <p className="name">
          qier-progress
        </p>
        <div className="describe"><p>A slim and color progress bar. With realistic trickle animations to tell your users that something's happening!</p></div>
        <div className="control-wrap">
          <div className="control" ref={this.controlRef}>
            <div className="create">
              const qprogress = new QProgress()
            </div>
            <p className="first-p">
              <button className="button" onClick={this.start}></button>
              <i>qprogress</i>
              <b>.start()</b>
              &nbsp;
              —&nbsp;shows the progress bar
            </p>
            <p>
              <button className="button" onClick={this.set}></button>
              <i>qprogress</i>
              <b>.set(0.1)</b>
              &nbsp;
              —&nbsp;sets a percentage
            </p>
            <p>
              <button className="button" onClick={this.inc}></button>
              <i>qprogress</i>
              <b>.inc(0.1)</b>
              &nbsp;
              —&nbsp;increments by a little
            </p>
            <p>
              <button className="button" onClick={this.finish}></button>
              <i>qprogress</i>
              <b>.finish()</b>
              &nbsp;
              —&nbsp;completes the progress
            </p>
          </div>
        </div>
        <p className="endword">Perfect for ajax request, file or iframe load, and other scenes.</p>
        <div className="github">
          <a href="https://github.com/vortesnail/qier-progress">
            <div className="github-btn">
              <img src={github} alt="github"/>
              <p>GitHub</p>
            </div>
          </a>
        </div>
        <div className="shadow"></div>
        <div className="thanks">🌸As you can see, <a target="_blank" href="https://github.com/vortesnail/qier-progress">qier-progress</a> uses typescript to refactor <a href="https://github.com/rstacruz/nprogress/" target="_blank">nprogress</a>, more features, and has better type annotations.</div>
      </div>
    );
  }
}

export default App;
